module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading,
      "fixed": true
    }
  }) : _vm._e()], 1) : (_vm.forecast && (_vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER) || _vm.hasAccessByProfile(_vm.PROFILES.ZONES_SUPERVISOR))) ? _c('div', {
    staticClass: "wrapper"
  }, [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading,
      "fixed": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px",
      "display": "flex"
    }
  }, [_c('div', [_c('DefaultButton', {
    on: {
      "click": function($event) {
        _vm.$router.push(("" + (_vm.ROUTES.BASE)))
      }
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "auto"
    }
  }, [(_vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER) && _vm.forecast.status === _vm.status.CLOSED) ? _c('div', [(!_vm.forecast.transmissionApprovalDate) ? _c('DefaultButton', {
    attrs: {
      "size": 'l'
    },
    on: {
      "click": _vm.approveTransmission
    }
  }, [_vm._v(" Approve ")]) : _c('div', [(_vm.forecast.transmissionApprovalBy) ? _c('p', [_vm._v("\n                        Approved by: " + _vm._s(_vm.forecast.transmissionApprovalBy.lastname) + ", " + _vm._s(_vm.forecast.transmissionApprovalBy.firstname) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Approved on: " + _vm._s(_vm.formatDate(_vm.forecast.transmissionApprovalDate)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.forecast.status === _vm.status.DRAFT && _vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER)) ? _c('div', [_c('DefaultButton', {
    attrs: {
      "size": 'l'
    },
    on: {
      "click": function($event) {
        _vm.publish(true)
      }
    }
  }, [_vm._v(" Publish Forecast for affiliate zones only ")]), _vm._v(" "), (false) ? _c('DefaultButton', {
    attrs: {
      "size": 'l'
    },
    on: {
      "click": function($event) {
        _vm.publish(false)
      }
    }
  }, [_vm._v("\n                    Publish Forecast for all zones (including Export)\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    (_vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER) || _vm.hasAccessByProfile(_vm.PROFILES.ZONES_SUPERVISOR)) &&
    _vm.forecast.status === _vm.status.ACTIVE &&
    _vm.forecast.publishMode !== 'all_zones'
  ) ? _c('div', [_c('DefaultButton', {
    attrs: {
      "size": 'l'
    },
    on: {
      "click": function($event) {
        _vm.$router.push(((_vm.ROUTES.BASE) + "/" + (_vm.forecast.id) + "/secondary-windows"))
      }
    }
  }, [_vm._v("\n                    Publish management\n                ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', [_c('ForecastNameBanner', {
    attrs: {
      "forecast": _vm.forecast
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('ForecastInfos', {
    attrs: {
      "forecast": _vm.forecast,
      "forecastWindows": _vm.forecastWindows
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('div', {
    staticClass: "actions"
  }, [(_vm.canReChallenge) ? _c('div', [_c('IconButton', {
    attrs: {
      "background-color": _vm.FORECAST_WINDOW_COLORS.RE_CHALLENGED,
      "height": '53px',
      "disabled": !_vm.hasForecastWindowsOpen
    },
    on: {
      "click": function($event) {
        _vm.isReChallengeModalVisible = true
      }
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('ReChallengeIcon')], 1), _vm._v("\n                        Re-challenge markets\n                    ")], 2)], 1) : _vm._e(), _vm._v(" "), (
    (_vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER) || _vm.hasAccessByProfile(_vm.PROFILES.ZONES_SUPERVISOR)) &&
    _vm.forecast.status !== _vm.status.DRAFT &&
    _vm.forecast.status !== _vm.status.PENDING &&
    _vm.hasAtLeastOneSubmission
  ) ? _c('div', [_c('IconButton', {
    attrs: {
      "height": '53px'
    },
    on: {
      "click": _vm.exportXls
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('ExportXlsIcon')], 1), _vm._v("\n                        Export Forecast Summary\n                    ")], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER)) ? _c('div', {
    on: {
      "mouseenter": function($event) {
        _vm.isOptionsMenVisible = true
      },
      "mouseleave": function($event) {
        _vm.isOptionsMenVisible = false
      }
    }
  }, [_c('IconButton', {
    attrs: {
      "width": '55px',
      "icon-only": true
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('EditIcon')], 1)], 2), _vm._v(" "), (_vm.isOptionsMenVisible) ? _c('div', {
    staticClass: "optionsMenu"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.canModify) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.currentMode = _vm.MODES.EDIT
      }
    }
  }, [_vm._v("Modify")]) : _vm._e(), _vm._v(" "), (_vm.ForecastValidator.canDuplicate(_vm.forecast) && _vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER)) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.isDuplicationModalVisible = true
      }
    }
  }, [_vm._v("\n                                Duplicate\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separation"
  }), _vm._v(" "), (_vm.ForecastValidator.canDelete(_vm.forecast) && _vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER)) ? _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.deleteForecast
    }
  }, [_vm._v("\n                                Delete\n                            ")]) : _vm._e()])]) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), (_vm.currentMode === _vm.MODES.SHOW) ? _c('div', {
    staticClass: "corp"
  }, [_c('div', [_c('CalendarInfo', {
    attrs: {
      "forecast": _vm.forecast
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.forecast) ? _c('Comments', {
    attrs: {
      "forecast": _vm.forecast
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "SectionBorderTop"
  }, [_c('ZonesDetail', {
    attrs: {
      "forecast": _vm.forecast,
      "forecast-windows": _vm.forecastWindows
    }
  })], 1), _vm._v(" "), _c('ItemManager', {
    staticClass: "mt-5",
    attrs: {
      "forecast": _vm.forecast,
      "forecast-windows": _vm.forecastWindows
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === _vm.MODES.EDIT && _vm.forecast) ? _c('ForecastEdit', {
    attrs: {
      "forecast": _vm.forecast
    },
    on: {
      "close": _vm.onEditModalClose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDuplicationModalVisible) ? _c('DuplicationModal', {
    attrs: {
      "forecast": _vm.forecast
    },
    on: {
      "closed": function($event) {
        _vm.isDuplicationModalVisible = false
      },
      "duplicated": _vm.onDuplicated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isReChallengeModalVisible) ? _c('ReChallengeModal', {
    attrs: {
      "forecast": _vm.forecast,
      "providedForecastWindows": _vm.forecastWindows
    },
    on: {
      "closed": function($event) {
        _vm.isReChallengeModalVisible = false
      },
      "rechallenged": _vm.loadForecastWindows
    }
  }) : _vm._e()], 1) : (!_vm.forecast && !_vm.isLoading) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px",
      "display": "flex"
    }
  }, [_c('div', [_c('DefaultButton', {
    on: {
      "click": function($event) {
        _vm.$router.push(("" + (_vm.ROUTES.BASE)))
      }
    }
  }, [_vm._v("« Back")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t("launchForecast.notAvailable")))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81f03610","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/ForecastDetail.vue
// module id = 3299
// module chunks = 0